<template>
    <controlbar-wrapper class="appbar">
        <mq-layout :mq="['sm', 'md', 'lg']" class="cb-section">
            <icon-button icon="folder-tree" size="2x" @click="$emit('showSidebar', !showSidebar)"
                    aria-controls="mainsidebar"></icon-button>
        </mq-layout>
        <mq-layout mq="sm" class="cb-section">
            <drop-menu-button icon="bars" size="2x" :options="settingOptions" tabindex="-1"
                    :title="$t('appbar.settings')"
                    @menu="doMenu" menuname="settingsMenu"></drop-menu-button>
        </mq-layout>
        <div class="cb-section">
            <icon-button icon="pencil" size="2x" tabindex="-1" :title="$t('appbar.newMessage')" @click="doCompose"/>
            <drop-menu-button icon="cog" size="2x" :options="options" tabindex="-1" :title="$t('appbar.tools')"
                    @menu="doMenu" menuname="toolMenu" class="mq-mdplus"></drop-menu-button>
            <icon-button icon="address-book" size="2x" tabindex="-1" class="mq-mdplus"
                    @click="$router.push({ name: 'addresses' })" :title="$t('appbar.addresses')"></icon-button>
            <icon-button icon="at" size="2x" tabindex="-1" @click="showInbox" :title="$t('appbar.messages')"/>
            <icon-button icon="calendar-alt" size="2x" tabindex="-1" @click="$router.push('/calendar')"
                    :title="$t('appbar.calendar')" ></icon-button>
            <logout size="2x" :title="$t('appbar.logout')" tabindex="-1" class="mq-sm"></logout>
        </div>
        <mq-layout mq="md+" class="cb-section cb-right">
            <icon-button size="2x" :title="$t('appbar.account')" tabindex="-1" @click="$router.push('/account')">
                <user-icon :name="$store.state.username" size="2x"></user-icon>
            </icon-button>
            <logout size="2x" :title="$t('appbar.logout')" tabindex="-1"></logout>
        </mq-layout>
    </controlbar-wrapper>
</template>

<script>
import ControlbarWrapper from '@/components/controlbarWrapper';
import IconButton from '@/components/iconButton';
import Logout from '@/components/logout';
import UserIcon from '@/components/userIcon';
import DropMenuButton from '@/components/DropMenuButton';
import { EventBus } from '@/event-bus';

export default {
  name: 'appToolbar',
  components: {
    DropMenuButton,
    IconButton,
    ControlbarWrapper,
    Logout,
    UserIcon
  },
  data: function() {
    return {
      options: [
        { text: this.$t('appbar.settings'), value: 'settings' },
        { text: this.$t('appbar.rules'), value: 'rules' },
        { text: this.$t('appbar.runRules'), value: 'runRules' }
      ],
      settingOptions: [
        { text: this.$t('appbar.folders'), value: 'folders' },
        { text: this.$t('appbar.addresses'), value: 'addresses' },
        { text: this.$t('appbar.settings'), value: 'settings' },
        { text: this.$t('appbar.rules'), value: 'rules' },
        { text: this.$t('appbar.runRules'), value: 'runRules' }
      ]
    };
  },
  props: {
    showSidebar: Boolean
  },
  methods: {
    doCompose() {
      EventBus.$emit('compose', {
        rcptsTo: [],
        subject: '',
        content: ''
      });
      // this.$store.commit('setEditorMode', 1);
    },
    doMenu(menu) {
      console.log(this.$route);
      // const base = `/${this.$route.params['foldertype']}/${this.$route.params['folderid']}`;
      if (menu === 'rules') {
        this.$router.push({ name: 'rules' });
      } else if (menu === 'runRules') {
        this.$router.push({ name: 'runManualRules' });
      } else if (menu === 'settings') {
        this.$router.push({ name: 'settings' });
      } else if (menu === 'addresses') {
        this.$router.push({ name: 'addresses' });
      } else if (menu === 'folders') {
        this.$router.push({ name: 'folders' });
      }
    },
    showInbox() {
      this.$router.push(`/n/${this.$store.getters.getFolderByName('Inbox').id}/1`);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .controlbarwrapper {
        &:focus {
            // background-color: red;
        }
        // height: 38px;
        background-color: $gray-200;
        background: linear-gradient(180deg, $gray-200 0%, $gray-100 35%, $white                  100%);
        border-bottom: 1px solid $control-bar-border;
    }

</style>
